import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const EMPTY = { nome: "", url: "", username: "", password: "", note: "" };

export const AccessFormDialog = ({ open, onOpenChange, item, clientId, onSaved }) => {
  const [f, setF] = useState(EMPTY);
  const [show, setShow] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) { setF(item ? { ...EMPTY, ...item, password: "" } : EMPTY); setShow(false); } }, [open, item]);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!f.nome.trim()) return toast.error("Inserisci il nome del portale");
    setSaving(true);
    const body = { nome: f.nome, url: f.url, username: f.username, note: f.note, password: item && !f.password ? undefined : f.password };
    try {
      item ? await api.put(`/accessi/${item.id}`, body) : await api.post(`/clients/${clientId}/accessi`, body);
      toast.success(item ? "Accesso aggiornato" : "Accesso salvato");
      onSaved?.();
      onOpenChange(false);
    } catch (err) { toast.error(errMsg(err)); }
    finally { setSaving(false); }
  };

  const F = (k, label, props = {}) => (
    <div className="space-y-1.5">
      <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">{label}</Label>
      <Input value={f[k]} onChange={set(k)} className="rounded-xl" data-testid={`access-form-${k}`} {...props} />
    </div>
  );

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-2xl" data-testid="access-form-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl font-black text-[#0A1128]">{item ? "Modifica accesso" : "Nuovo accesso"}</DialogTitle></DialogHeader>
        <form onSubmit={submit} className="space-y-4" autoComplete="off">
          {F("nome", "Nome portale / servizio *")}
          {F("url", "URL", { placeholder: "https://..." })}
          {F("username", "Username / email", { autoComplete: "off" })}
          <div className="space-y-1.5">
            <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">Password</Label>
            <div className="relative">
              <Input type={show ? "text" : "password"} value={f.password} onChange={set("password")} autoComplete="new-password"
                placeholder={item?.has_password ? "Lascia vuoto per non modificarla" : ""} className="rounded-xl pr-10" data-testid="access-form-password" />
              <button type="button" onClick={() => setShow((s) => !s)} className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-[#0A1128]" data-testid="access-form-toggle-password">
                {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
              </button>
            </div>
          </div>
          <div className="space-y-1.5">
            <Label className="text-xs font-bold uppercase tracking-wider text-slate-500">Note</Label>
            <Textarea rows={2} value={f.note} onChange={set("note")} className="rounded-xl" data-testid="access-form-note" />
          </div>
          <DialogFooter>
            <Button type="button" variant="ghost" className="rounded-full" onClick={() => onOpenChange(false)} data-testid="access-form-cancel">Annulla</Button>
            <Button type="submit" disabled={saving} className="rounded-full bg-[#E8173A] hover:bg-[#C8102E] px-6" data-testid="access-form-submit">{saving ? "Salvataggio..." : "Salva"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
